import { isExistFeatureFlag } from '@/service/feature/isExistFeatureFlag';
import { isBetaFacility } from '@/service/facility/isBetaFacility';
import { isContactToScheduleApplyRolloutPublic } from '@/service/parentContacts/isContactToScheduleApplyRolloutPublic';

const FEATURE_KEY = 'useContactV3Api';

// 連絡即予定反映の段階リリースの経路が成立しているかを判定する。施設の学童・利用申請の設定値は見ない。
// ロールアウトフラグが全施設に公開済みなら成立。そうでなければ、useContactV3Api の feature_flags と beta_facilities の両方があるときだけ成立。
// いずれの取得も失敗は「成立しない」として扱われる。
export const isContactToScheduleApplyFlagPathOpen = async (): Promise<boolean> => {
  if (await isContactToScheduleApplyRolloutPublic()) {
    return true;
  }

  const [hasFlag, isBeta] = await Promise.all([isExistFeatureFlag(FEATURE_KEY), isBetaFacility(FEATURE_KEY)]);
  return hasFlag && isBeta;
};
